module.exports = __webpack_public_path__ + "static/img/tree-right.5ec2350.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hellohr/tree-right.png
// module id = +s5q
// module chunks = 0